import { useEffect, useState } from "react";
import { Button, Card, CardMedia, Grid, Typography } from "@mui/material";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { z } from "zod";
import showToast from "../../../components/Hot-Toast/showToast";
import { customStep, nextStep, update } from "../../../slice/jobSlice";
import { useTMutation } from "../../../utils/useTMutation";
import CheckIcon from '@mui/icons-material/Check'; // Importing the checkmark icon from MUI
import image1 from '../../../assets/images/image52.png'
import image2 from '../../../assets/images/image53.png'
import image3 from '../../../assets/images/image54.png'
import image4 from '../../../assets/images/image55.png'
import image5 from '../../../assets/images/image56.png'
import { assignedColorList } from "../../../utils/genericMethod";


const JobContractType = () => {
    const { mutateAsync } = useTMutation("/job/addUpdateJob", "post", (data => { return data }));
    const { jobData, step } = useSelector(state => state?.job);
    const { userDetails } = useSelector(state => state?.user);
    const navigate = useNavigate();
    const dispatch = useDispatch();



    // Define state to keep track of the selected item
    const [selectedSolution, setSelectedSolution] = useState(jobData?.JOB_TYPE || "");

    const contractTypeArray = [
        {
            heading: "CONTRACT",
            subtitle: "All Job Roles",
            subchild:"Contract-Based Services",
            image: image1
        },
        {
            heading: "TEMP-TO-HIRE OPPORTUNITIES",
            subtitle: "All Job Roles",
            subchild:" Hospital Careers",
            image: image2
        }
        , {
            heading: "PERMANENT POSITIONS",
            subtitle: "All Job Roles",
            subchild:"Build Your Career in Healthcare",
            image: image3
        }, {
            heading: "PER DIEM WORK",
            subtitle: "All NP/Non-Clinician",
            subchild:"Flexible Shifts in Healthcare",
            image: image4
        }, {
            heading: "TRAVEL NURSES",
            subtitle: "Only RN",
            subchild:"Explore Opportunities in Leading Hospitals",
            image: image5
        }

    ];

    const colorArray = ['#4CAF50', '#3BB9E3', '#F6B613', '#073463', '#7E57E2'];

    const onSubmitNext = async (data) => {
        if (jobData?.ID) data.ID = jobData?.ID;
        else data.USER_ID = userDetails.ID;

        try {
            const response = await mutateAsync({ ...data, STEP: jobData?.REDIRECT ? 8 : step + 1, HIRING_TYPE: jobData?.HIRING_TYPE });
            if (response.STATUS) {
                dispatch(update(jobData?.ID ? data : response.OUTPUT));
                if (jobData?.REDIRECT) {
                    dispatch(customStep(8));
                    dispatch(update({ "REDIRECT": false }));
                } else {
                    dispatch(nextStep());
                }
            } else {
                showToast("error", data.MESSAGE, 3000);
            }
        } catch (error) {
            console.error("Validation Request failed:", error.message);
            showToast("error", "Something went wrong, Please try again", 3000);
        }
    };

    const handleClick = (solution) => {

        if (solution) {
            setSelectedSolution(solution); // Update selected solution
            onSubmitNext({ JOB_TYPE: solution });// Submit the selected solution
        } else {
            showToast("error", "Please select at least one Staff");
        }
    };

    const [assignedColors, setAssignedColors] = useState([]);

    // Fetch the assigned colors asynchronously when the component mounts
    useEffect(() => {
        const fetchAssignedColors = async () => {
            const items = contractTypeArray;
            const colors = ['#4CAF50', '#3BB9E3', '#F6B613', '#073463', '#7E57E2'];
            const colorsAssigned = await assignedColorList(items, colors);
            setAssignedColors(colorsAssigned);
        };
        fetchAssignedColors();
    }, [assignedColorList]);

    return (
        <>

            <Grid container alignItems="center" px={3} pb={3} spacing={2}>
                <Grid item xs={12} sm={12} mt={2}>
                    <Typography variant="h3" className="about-texts">
                        {/* Which type of staff are you seeking ? */}
                        What type of support are you looking for?
                    </Typography>
                </Grid>

                {contractTypeArray.map((val, index) => {
                    // const color = colorArray[Math.floor(Math.random() * colorArray.length)];
                    const color = assignedColors[index]
                    const isSelected = selectedSolution === val.heading; // Check if the current solution is selected
                    console.log(val.heading, isSelected)
                    return (
                        <Grid
                            item
                            lg={12}
                            p={1}
                            key={index}
                            onClick={() => handleClick(val.heading)}
                            style={{
                                position: 'relative', // Position for placing the checkmark icon
                                cursor: "pointer",
                                transition: "transform 0.3s ease", // Smooth scaling transition
                                transform: isSelected ? "scale(1.05)" : "scale(1)", // Slightly enlarge when selected
                            }}
                            onMouseEnter={(e) => { e.currentTarget.style.transform = "scale(1.05)"; }} // Hover scale
                            onMouseLeave={(e) => { e.currentTarget.style.transform = isSelected ? "scale(1.05)" : "scale(1)"; }} // Revert on hover out
                        >
                            <Grid
                                p={2}
                                style={{
                                    borderRadius: "3px",
                                    border: `2px solid ${color}`,
                                    backgroundColor: isSelected ? color : "transparent", // Change background if selected
                                    position: 'relative',
                                }}
                            >
                                {isSelected && (
                                    <CheckIcon
                                        style={{
                                            position: 'absolute',
                                            top: '8px',
                                            right: '8px',
                                            color: '#fff', // White checkmark
                                            fontSize: '24px',
                                        }}
                                    />
                                )}
                                <Grid container >
                                    <Grid item lg={2} style={{ background: color, borderRadius: "100px" }} p={2}>
                                        <CardMedia
                                            component="img"
                                            height="40"
                                            width="40"
                                            image={val?.image}
                                            alt="Card image"
                                        />

                                    </Grid>
                                    <Grid item lg={10} pl={2}>
                                        <Typography style={{ color: isSelected ? "#fff" : color }}>
                                            {val?.heading}
                                        </Typography>
                                        <Typography>
                                            {val?.subtitle}
                                        </Typography>
                                        <Typography>
                                            {val?.subchild}
                                        </Typography>
                                    </Grid>
                                </Grid>

                            </Grid>
                        </Grid>
                    );
                })}
            </Grid>

            

        </>
    );
};

export default JobContractType;
